import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dropdown from '../Dropdown';
import IconUser from '../Icon/IconUser';
// import IconMail from '../Icon/IconMail';
import IconLogout from '../Icon/IconLogout';
import IconCaretDown from '../Icon/IconCaretDown';
import IconMenuCharts from '../Icon/Menu/IconMenuCharts';
import IconEthereum from '../Icon/IconSolana';
import IconMenuUsers from '../Icon/Menu/IconMenuUsers';
import IconMenuDocumentation from '../Icon/Menu/IconMenuDocumentation';
import { useAuth } from './context/Authcontext';
import { useNavigate } from 'react-router-dom';
import UserLevelDashboards from '../../pages/Dashboard/UserLevelMainTab';
import QualityAuditorMainTab from '../../pages/Dashboard/QualityAuditorMainTab';
import AMDMMainTab from '../../pages/Dashboard/AMDMMainTab';
// import QualityManagerDashboardMain from '../pagecomponents/DashboardComp/QualityManagerDashboard/QualityManagerDashboardMain';
import MainReports from '../pagecomponents/BiReports/MainReports';
import { IconAlarm, IconBookmarks } from '@tabler/icons-react';
import QMDashboardMain from '../pagecomponents/DashboardComp/QualityManagerDashboard/QMDashboardMain';
import AuditErrorPopup from '../AuditErrorPopup';
import { useStartDateTime } from './context/StartDateTimeContext';
import { Trophy } from 'lucide-react'; // ensure Trophy is imported
import { FaListAlt } from 'react-icons/fa';
import { Wrench, MessageSquareText } from 'lucide-react';
import ProfileImage from '../../pages/ProfileImage';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const selector = document.querySelector('ul.horizontal-menu a[href="' + window.location.pathname + '"]');
    if (selector) {
      selector.classList.add('active');
      const all = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
      for (let i = 0; i < all.length; i++) {
        all[0]?.classList.remove('active');
      }
      const ul = selector.closest('ul.sub-menu');
      if (ul) {
        let ele = ul.closest('li.menu').querySelectorAll('.nav-link');
        if (ele) {
          ele = ele[0];
          setTimeout(() => {
            ele?.classList.add('active');
          });
        }
      }
    }
  }, [location]);

  const isRtl = useSelector((state) => state.themeConfig.rtlClass) === 'rtl' ? true : false;

  const themeConfig = useSelector((state) => state.themeConfig);
  const { t } = useTranslation();

  const [isRrOpen, setIsRrOpen] = useState(false);

  const [isRTMainOpen, setRTMainOpen] = useState(false);
  const [isRTSearchOpen, setRTSearchOpen] = useState(false);
  const [isMainMenuOpen, setMainMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isSubSubmenuOpen, setIsSubSubmenuOpen] = useState(false);
  const [isProdReportOpen, setProdReportOpen] = useState(false);
  const [isProdMastersOpen, setProdMastersOpen] = useState(false);
  const [isQAReportOpen, setQAReportOpen] = useState(false);
  const [isSuperAuditOpen, setSuperAuditOpen] = useState(false);
  const [isAuditOpen, setAuditOpen] = useState(false);
  const [isAuditEntryOpen, setAuditEntryOpen] = useState(false);
  const [isQATemplateOpen, setQATemplateOpen] = useState(false);
  const [isSAErrorOpen, setSAErrorOpen] = useState(false);
  const [isSAEntryOpen, setSAEntryOpen] = useState(false);
  const [isCoachingOpen, setCoachingOpen] = useState(false);
  const [isAllocationTypeOpen, setAllocationTypeOpen] = useState(false);
  const [toggleUpdateEmployeePerformanceData, settoggleUpdateEmployeePerformanceData] = useState(false);
  const menuRef = useRef(null);
  const { role, username, logout, name, employeeID } = useAuth();
  const [isAuditRebuttalOpen, setAuditRebuttalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false); // For logout warning modal
  const timeout = 900000; // 15 minutes (in milliseconds)
  const warningTimeout = 840000; // 14 minute warning
  const timerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const [isSuperAuditRebuttalOpen, setSuperAuditRebuttalOpen] = useState(false);
  const [SuperAuditReportOpen, setSuperAuditReportOpen] = useState(false);
  const modalAcknowledgedRef = useRef(false);
  const {
    activeScreen,
    setFlagForScreen,
    setLogoutSaveFlag,
    logoutTriggered,
    setLogoutTriggered,
    logoutInProgress,
    setLogoutInProgress,
  } = useStartDateTime();

  // const searchWrapperRef = useRef(null);

  useEffect(() => {
    if (location.pathname === '/') {
      // This replaces current state and prevents going back
      window.history.pushState(null, '', window.location.href);

      const handlePopState = () => {
        window.history.pushState(null, '', window.location.href);
      };

      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [location.pathname]);

  // Map roles to titles
  const roleBasedTitles = {
    employee: 'Employee Error Search',
    auditor: 'QA Auditor Error Search',
    'Assistant Manager': 'Assistant Manager Error Search',
    'Quality Manager': 'QA Quality Manager Error Search',
    'Super Admin': 'Manager Error Search',
  };

  // Map roles to titles
  const roleBasedFyiStatusTitles = {
    employee: 'Employee Fyi Status Search',
    auditor: 'QA Auditor Fyi Status Search',
    'Assistant Manager': 'Assistant Manager Fyi Status Search',
    'Quality Manager': 'QA Quality Manager Fyi Status Search',
    'Super Admin': 'Manager Fyi Status Search',
  };

  const roleBasedReWorkTitles = {
    employee: 'Employee Rework Search',
    auditor: 'QA Auditor Rework Search',
    'Assistant Manager': 'Assistant Manager Rework Search',
    'Quality Manager': 'QA Quality Manager Rework Search',
    'Super Admin': 'Admin Rework Search',
  };

  // Map roles to titles
  const roleBasedSuperAuditTitles = {
    auditor: 'QA Auditor Super Audit Error Search',
    'Super Audit': 'QA Super Audit Error Search',
    'Assistant Manager': 'Assistant Manager Super Audit Error Search',
    'Quality Manager': 'QA Quality Manager Super Audit Error Search',
    'Super Admin': 'Manager Super Audit Error Search',
  };

  // Map roles to titles
  const roleBasedSuperAuditFyiStatusTitles = {
    auditor: 'QA Auditor Super Audit Fyi Status',
    'Super Audit': 'QA Super Audit  Fyi Status',
    'Assistant Manager': 'Assistant Manager Super Audit  Fyi Status',
    'Quality Manager': 'QA Quality Manager Super Audit  Fyi Status',
    'Super Admin': 'Manager Super Audit Fyi Status',
  };

  const superAudititle = roleBasedSuperAuditTitles[role] || 'QA Super Audit Status'; // Default title

  const superAuditFyiStatusitle = roleBasedSuperAuditFyiStatusTitles[role] || 'QA Super Audit Fyi Status'; // Default title

  const fyiStatusTitle = roleBasedFyiStatusTitles[role] || 'QA Fyi Status'; // Default title

  const title = roleBasedTitles[role] || 'QA Error Search'; // Default title

  const reWorkStatusTitle = roleBasedReWorkTitles[role] || 'QA ReWork Search'; // Default title
  const originalTitle = useRef(document.title);
  const blinkIntervalRef = useRef(null);
  const faviconBlinkRef = useRef(null);
  const showModalRef = useRef(false);

  useEffect(() => {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
  }, []);

  const startTitleBlink = () => {
    if (blinkIntervalRef.current) return;

    let visible = false;
    blinkIntervalRef.current = setInterval(() => {
      document.title = visible ? '🔔 🔴 INACTIVITY ALERT!' : '⚠️ Please Return!';
      visible = !visible;
    }, 500); // faster blink

    let faviconState = true;
    faviconBlinkRef.current = setInterval(() => {
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = faviconState ? '/favicon-alert.ico' : '/favicon.ico';
        faviconState = !faviconState;
      }
    }, 1000);
  };

  const stopTitleBlink = () => {
    clearInterval(blinkIntervalRef.current);
    blinkIntervalRef.current = null;

    clearInterval(faviconBlinkRef.current);
    faviconBlinkRef.current = null;

    document.title = originalTitle.current;

    const link = document.querySelector("link[rel~='icon']");
    if (link) link.href = '/favicon.ico';
  };

  const handleLogout = async () => {
    logout();

    navigate('/login', { replace: true });
  };

  // put this at module scope
  const EXEMPT_ROUTES = new Set(['/ClientMgmt/ClientView', '/ClientMgmt']);

  const handleAutoLogout = async () => {
    const { pathname } = location;
    //  Hard-exclude specific routes
    if (EXEMPT_ROUTES.has(pathname)) {
      return;
    }

    const uniqueKey = `${activeScreen.pathname}-${activeScreen.screenName}`;

    if (
      location.pathname === '/Production/AllocationFilesTemplate/AddEditAlloFileLogEntry' ||
      location.pathname === '/Production/AllocationFilesTemplate/AddEditAlloTemplateLogEntry'
    ) {
      setFlagForScreen(uniqueKey, true);
      setLogoutTriggered(true);

      // Wait a little to allow AddNewFileEntry to run auto-save
      await new Promise((resolve) => setTimeout(resolve, 500));
    }

    // Clear flags after save is completed
    setFlagForScreen(uniqueKey, false);
    setLogoutTriggered(false);
    logout(); // Clear authentication state
    navigate('/login', { replace: true });
  };

  const handleStayLoggedIn = () => {
    modalAcknowledgedRef.current = true;
    setShowModal(false);
    showModalRef.current = false; // 🔄 Sync ref
    stopTitleBlink();
    resetTimer();
  };

  useEffect(() => {
    if (showModal) {
      const finalTimer = setTimeout(() => {
        stopTitleBlink();
        handleAutoLogout();
      }, 60000); // 1 minute logout countdown after modal shown

      return () => clearTimeout(finalTimer); // Cleanup on modal close
    }
  }, [showModal]);

  // Function to show the logout warning
  const logoutWarning = () => {
    //   const { pathname } = location;

    // // Skip warning completely on exempt routes
    // if (EXEMPT_ROUTES.has(pathname)) {
    //   return;
    // }
    const currentPath = window.location.pathname;

    // Skip warning completely on exempt routes
    if (EXEMPT_ROUTES.has(currentPath)) {
      return;
    }

    if (document.hidden) startTitleBlink();

    setShowModal(true);
    showModalRef.current = true; // 🔄 Sync ref

    if (Notification.permission === 'granted') {
      const notification = new Notification('⚠️ You will be logged out soon!', {
        body: 'Click here to return to the app.',
        icon: '/favicon.png',
        requireInteraction: true,
      });

      notification.onclick = () => {
        window.focus();
      };
    }

    // warningTimerRef.current = setTimeout(() => {
    //   stopTitleBlink();
    //   handleLogout();
    // }, timeout - warningTimeout);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        stopTitleBlink(); // Stop blinking when user returns
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Function to reset the timer
  const resetTimer = (eventType = '') => {
    clearTimeout(timerRef.current);
    clearTimeout(warningTimerRef.current);

    if (showModalRef.current && !modalAcknowledgedRef.current) {
      if (eventType !== 'click' && eventType !== 'keydown') {
        return;
      }
    }

    stopTitleBlink();
    setShowModal(false);
    showModalRef.current = false; // 🔄 Sync ref
    modalAcknowledgedRef.current = false;

    const currentPath = window.location.pathname;

    // ⛔ Skip scheduling timers completely for exempt routes
    if (EXEMPT_ROUTES.has(currentPath)) {
      return;
    }

    timerRef.current = setTimeout(logoutWarning, warningTimeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

    const handleActivity = (e) => resetTimer(e.type);

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      clearTimeout(timerRef.current);
      clearTimeout(warningTimerRef.current);
    };
  }, []);

  useEffect(() => {
    const selector = document.querySelector('ul.horizontal-menu a[href="' + window.location.pathname + '"]');
    if (selector) {
      selector.classList.add('active');
    }
  }, [location]);

  //   useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (
  //       searchWrapperRef.current &&
  //       !searchWrapperRef.current.contains(event.target)
  //     ) {
  //       setFilteredRoutes([]);      // Close dropdown
  //       setSearchTerm('');          // Clear input field
  //       setSelectedIndex(-1);       // Reset arrow navigation index
  //     }
  //   }

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  // Toggle function for the RT Main Menu (isRTMainOpen)
  const toggleRTMainOpen = () => {
    setRTMainOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setProdReportOpen(false);
        setProdMastersOpen(false);
        setAuditOpen(false);
        setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleMasters = () => {
    setProdMastersOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdReportOpen(false);
        setSuperAuditOpen(false);
        setAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleProdReport = () => {
    setProdReportOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setSuperAuditOpen(false);
        setAuditOpen(false);
        setAllocationTypeOpen(false);
      }
      return !prev;
    });
  };

  const toggleQAReport = () => {
    setQAReportOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setSuperAuditOpen(false);
        setAuditOpen(false);
        settoggleUpdateEmployeePerformanceData(false);
        setQATemplateOpen(false);
      }
      return !prev;
    });
  };

  const toggleUpdateEmployeePerformance = () => {
    settoggleUpdateEmployeePerformanceData((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setSuperAuditOpen(false);
        setAuditOpen(false);
        setQAReportOpen(false);
      }
      return !prev;
    });
  };

  const toggleCoaching = () => {
    setCoachingOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setSuperAuditOpen(false);
        setAuditOpen(false);
        setQAReportOpen(false);
      }
      return !prev;
    });
  };

  const toggleAudit = () => {
    setAuditOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleAuditEntry = () => {
    setAuditEntryOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleSuperAudit = () => {
    setSuperAuditOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setAuditOpen(false);
        setAuditEntryOpen(false);
        setQATemplateOpen(false);
      }
      return !prev;
    });
  };

  const toggleSAEntry = () => {
    setSAEntryOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setAuditOpen(false);
        setSAErrorOpen(false);
      }
      return !prev;
    });
  };

  const toggleSAError = () => {
    setSAErrorOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setAuditOpen(false);
        setSAEntryOpen(false);
      }
      return !prev;
    });
  };

  const toggleAuditRebuttalEntry = () => {
    setAuditRebuttalOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleSuperAuditRebuttalEntry = () => {
    setSuperAuditRebuttalOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        // setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleSuperAuditReport = () => {
    setSuperAuditReportOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        // setSuperAuditOpen(false);
      }
      return !prev;
    });
  };

  const toggleQATemplate = () => {
    setQATemplateOpen((prev) => {
      if (!prev) {
        setMainMenuOpen(false);
        setRTMainOpen(false);
        setProdMastersOpen(false);
        setQAReportOpen(false);
        setAuditOpen(false);
        setSAEntryOpen(false);
        setSAErrorOpen(false);
        setSuperAuditOpen(false);
      }
      return !prev;
    });
  };
  // useEffect(() => {
  //   const fetchProfileImage = async () => {
  //     try {
  //       let baseUrls= getRoundRobinBaseUrl();
  //       const response = await axios.get(
  //         `${baseUrls}/auth/allUsersEmployeeImage?employeeID=${employeeID}`, // Assuming `employeeID` stores employee ID
  //         {
  //           headers: { Authorization: `Bearer ${accessToken}` },
  //           responseType: 'arraybuffer', // Fetch binary image data
  //         }
  //       );

  //       if (response.data) {
  //         const base64Image = `data:image/jpeg;base64,${btoa(
  //           new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
  //         )}`;
  //         setProfileImage(base64Image);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching profile image:', error);
  //       setProfileImage('/assets/images/profile.png'); // Fallback image
  //     }
  //   };

  //   if (employeeID) {
  //     fetchProfileImage();
  //   }
  // }, [employeeID, accessToken]);

  return (
    <>
      <header className={`relative z-50 ${themeConfig.semidark && themeConfig.menu === 'horizontal' ? 'dark' : ''}`}>
        <div className="shadow-sm">
          <div className="relative bg-white flex justify-between w-full items-center px-5 py-2.5 dark:bg-black">
            {/* Logo Section */}
            <div className="horizontal-logo flex  items-center ltr:mr-2 rtl:ml-2">
              <Link to="/" className="main-logo flex items-center shrink-0">
                <img className="w-30 h-10 ltr:-ml-1 rtl:-mr-1 inline" src="/assets/images/Imaglogo.svg" alt="logo" />
                <span className="text-2xl ltr:ml-1.5 rtl:mr-1.5 font-semibold align-middle hidden md:inline dark:text-white-light transition-all duration-300">
                  EPR
                </span>
              </Link>
            </div>

            {/* <div className="relative ml-4 w-72 max-w-xs z-[999]">
                <div className="relative">
                  <input
                    type="text"
                    ref={searchWrapperRef}
                    placeholder="Menu Quick Search"
                    className="w-full px-4 py-2 pl-10 rounded-lg border border-[#d4dbe2] text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#A6B0C3] text-[#1A2B5C] placeholder-[#7c8aa0] bg-[#f8fafc] transition-all"
                    value={searchTerm}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'ArrowDown') {
                        setSelectedIndex((prev) => Math.min(prev + 1, filteredRoutes.length - 1));
                      } else if (e.key === 'ArrowUp') {
                        setSelectedIndex((prev) => Math.max(prev - 1, 0));
                      } else if (e.key === 'Enter' && filteredRoutes[selectedIndex]) {
                        handleRouteSelect(filteredRoutes[selectedIndex]);
                      }
                    }}
                  />

                  {/* Search Icon */}
            {/* <svg
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#A6B0C3] opacity-80"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z" />
                  </svg>
                </div>

                {filteredRoutes.length > 0 && (
                  <ul className="absolute mt-2 w-full bg-white border border-[#e2e8f0] rounded-md shadow-md max-h-56 overflow-y-auto text-sm">
                    {filteredRoutes.map((route, idx) => (
                      <li
                        key={route.name}
                        onClick={() => handleRouteSelect(route)}
                        className={`px-4 py-2 cursor-pointer transition-all ${
                          idx === selectedIndex
                            ? 'bg-[#e0e7ff] text-[#1A2B5C] font-medium'
                            : 'hover:bg-[#f1f5f9] text-[#475569]'
                        }`}
                      >
                        {route.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div> */}
            <div className="">
              <AuditErrorPopup />
            </div>

            {/* <div>
            <MessengerMain/>
            </div> */}

            {/* Profile Section: Aligned to the right using ml-auto */}
            <div className="flex items-center ml-auto">
              <div className="dropdown shrink-0 flex">
                <Dropdown
                  offset={[0, 8]}
                  placement={`${isRtl ? 'bottom-start' : 'bottom-end'}`}
                  btnClassName="relative group block mt-2 w-9 h-9 rounded-full overflow-hidden border-[3px] border-white shadow-lg ring-2 ring-primary hover:scale-105 transition-transform duration-200"
                  button={
                    <ProfileImage
                      employeeId={parseInt(employeeID)}
                      className="w-full h-full object-cover rounded-full"
                    />
                  }
                >
                  <ul className="w-[300px] text-dark dark:text-white-dark font-medium rounded-xl backdrop-blur-md bg-white/80 dark:bg-slate-800/80 shadow-2xl border border-gray-200 dark:border-slate-700 overflow-hidden">
                    {/* Profile Header */}
                    <li className="p-4 bg-gradient-to-r from-[#EE1D23] to-[#1A2B5C] text-white">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-[2px] border-white shadow-md">
                          <ProfileImage
                            employeeId={parseInt(employeeID)}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="truncate">
                          <h4 className="text-lg font-semibold">{name}</h4>
                          <div className="text-[13px] bg-white/20 px-2 py-1 rounded-full w-fit mt-1">{username}</div>
                        </div>
                      </div>
                    </li>

                    {/* Options */}
                    <li>
                      <Link
                        to="/users/profile"
                        className="flex items-center gap-3 px-4 py-3 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
                      >
                        <IconUser className="w-5 h-5 text-primary" />
                        <span className="text-sm">View Profile</span>
                      </Link>
                    </li>

                    {/* Future Lock Option */}
                    {/* <li>
          <Link
            to="/lockScreen"
            className="flex items-center gap-3 px-4 py-3 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
          >
            <IconLockDots className="w-5 h-5 text-primary" />
            <span className="text-sm">Lock Screen</span>
          </Link>
        </li> */}

                    {/* Logout */}
                    <li className="border-t border-gray-200 dark:border-slate-600">
                      <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 w-full px-4 py-3 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 transition"
                      >
                        <IconLogout className="w-5 h-5 rotate-90 text-red-600" />
                        <span className="text-sm">Sign Out</span>
                      </button>
                    </li>
                  </ul>
                </Dropdown>
              </div>
            </div>
          </div>

          {/* horizontal menu */}
          <ul className="horizontal-menu hidden py-1.5 font-semibold px-20 lg:space-x-1.5 xl:space-x-8 rtl:space-x-reverse bg-white border-t border-[#ebedf2] dark:border-[#191e3a] dark:bg-black text-black dark:text-white-dark">
            {/* <li className="menu nav-item relative">
            <button type="button" className="nav-link">
              <div className="flex items-center">
                <IconMenuApps className="shrink-0" />
                <span className="px-1">{t('SETUP')}</span>
              </div>
              <div className="right_arrow">
                <IconCaretDown />
              </div>
            </button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/">{t('Client')}</NavLink>
              </li>
              <li>
                <NavLink to="/Location">{t('Location')}</NavLink>
              </li>
              <li>
                <NavLink to="/Division">{t('Division')}</NavLink>
              </li>
              <li>
                <NavLink to="/Scope">{t('Scope')}</NavLink>
              </li>
            </ul>
          </li> */}
            {/* {Dashboard} */}
            {role === 'employee' && (
              <li className="menu nav-item relative">
                <NavLink to="/UserLevel" className="nav-link">
                  <div className="flex items-center">
                    <IconEthereum className="shrink-0" />
                    <span className="px-1">{t('DASHBOARD')}</span>
                  </div>
                </NavLink>
              </li>
            )}
            {role === 'auditor' && (
              <li className="menu nav-item relative">
                <NavLink to="/QualityAuditor" className="nav-link">
                  <div className="flex items-center">
                    <IconEthereum className="shrink-0" />
                    <span className="px-1">{t('DASHBOARD')}</span>
                  </div>
                </NavLink>
              </li>
            )}
            {role === 'Assistant Manager' && (
              <li className="menu nav-item relative">
                <NavLink to="/AMDM" className="nav-link">
                  <div className="flex items-center">
                    <IconEthereum className="shrink-0" />
                    <span className="px-1">{t('DASHBOARD')}</span>
                  </div>
                </NavLink>
              </li>
            )}
            {role === 'Super Admin' && (
              <li className="menu nav-item relative">
                <NavLink to="/BiReports/MainReports" className="nav-link">
                  <div className="flex items-center">
                    <IconEthereum className="shrink-0" />
                    <span className="px-1">{t('DASHBOARD')}</span>
                  </div>
                </NavLink>
              </li>
            )}
            {role === 'Quality Manager' && (
              <li className="menu nav-item relative">
                <NavLink to="/QualityManagerDashboard" className="nav-link">
                  <div className="flex items-center">
                    <IconEthereum className="shrink-0" />
                    <span className="px-1">{t('DASHBOARD')}</span>
                  </div>
                </NavLink>
              </li>
            )}

            {/* Masters */}
            {(role === 'Super Admin' ||
              role === 'Assistant Manager' ||
              role === 'employee' ||
              role === 'Super Audit' ||
              role === 'Quality Manager' ||
              role === 'auditor') && (
                <li className="menu nav-item relative">
                  <button type="button" className="nav-link">
                    <div className="flex items-center">
                      <IconMenuUsers className="shrink-0" />
                      <span className="px-1">{t('MASTERS')}</span>
                    </div>
                    <div className="right_arrow">
                      <IconCaretDown />
                    </div>
                  </button>
                  <ul className="sub-menu">
                    {/* User Management first */}
                    {role === 'Super Admin' && (
                      <li>
                        <NavLink to="/UserMgmt">{t('User Management')}</NavLink>
                      </li>
                    )}

                    {/* Client Management */}
                    <li>
                      <NavLink to="/ClientMgmt">{t('Client Management')}</NavLink>
                    </li>

                    {/* Division Management */}
                    {role === 'Super Admin' && (
                      <li>
                        <NavLink to="/DivisionMgmt">{t('Division Management')}</NavLink>
                      </li>
                    )}

                    {/* EndClient Management */}
                    {role === 'Super Admin' && (
                      <li>
                        <NavLink to="/EndClientMgmt">{t('EndClient Management')}</NavLink>
                      </li>
                    )}

                    <li>
                      <NavLink to="/ScopeMgmt">{t('Scope Management')}</NavLink>
                    </li>

                    {/* Role Management */}
                    {role === 'Super Admin' && (
                      <li>
                        <NavLink to="/RolesMgmt">{t('Role Management')}</NavLink>
                      </li>
                    )}

                    {/* CCHS */}
                    {(role === 'Super Admin' ||
                      role === 'Assistant Manager' ||
                      role === 'employee' ||
                      role === 'Quality Manager' ||
                      role === 'auditor') && (
                        <li>
                          <NavLink to="/ScopeMgmt/Data/Quality/AddEditCCHS">{t('CCHS')}</NavLink>
                        </li>
                      )}

                    {/* AR Category Exception */}
                    {role === 'Super Admin' && (
                      <>
                        <li>
                          <NavLink to="/ArCategoryException" className="block px-4 py-2 whitespace-nowrap">
                            {t('AR Category Exception Production')}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/ArCategoryExceptionAudit" className="block px-4 py-2 whitespace-nowrap">
                            {t('AR Category Exception Audit')}
                          </NavLink>
                        </li>
                      </>
                    )}

                    {/* Error Category & Weekly MOM */}
                    {role === 'Super Admin' && (
                      <>
                        <li>
                          <NavLink to="/ScopeMgmt/AddNewErrorCategory">{t('Error Category')}</NavLink>
                        </li>
                        <li>
                          <NavLink to="/ScopeMgmt/WeeklyMOM/AddEditWeeklyMOM">{t('Weekly MOM')}</NavLink>
                        </li>
                      </>
                    )}

                    {/* PBI Initiation */}
                    {(role === 'Super Admin' || 
                      role === 'Assistant Manager' || 
                      role === 'Quality Manager') && (
                      <>
                        <li>
                          <NavLink to="/ScopeMgmt/PBI/AddEditPBI">
                            {t('PBI Initiation')}
                          </NavLink>
                        </li>

                        <li>
                          <NavLink to="/Production/CoachingFeedback/RCASearch">
                            {t('RCA Search')}
                          </NavLink>
                        </li>

                        <li>
                          <NavLink to="/Production/CoachingFeedback/POASearch">
                            {t('POA Search')}
                          </NavLink>
                        </li>
                      </>
                    )}


                    {/* Inventory & Calibration config */}
                    {role === 'Super Admin' && (
                      <>
                        <li>
                          <NavLink to="/ScopeMgmt/ScopeData/InventoryAddEdit">{t('Inventory')}</NavLink>
                        </li>
                        <li>
                          <NavLink to="/ScopeMgmt/Data/Quality/CalibrationAddEdit">{t('Calibration config')}</NavLink>
                        </li>
                        {/* <li>
        <NavLink to="/ScopeMgmt/HierarchyConifg">{t('Hierarchy Config')}</NavLink>
      </li> */}
                      </>
                    )}

                    {/* Employee Life Cycle */}
                    {(role === 'Super Admin' || role === 'Assistant Manager' || role === 'employee') && (
                      <li>
                        <NavLink to="/Production/CoachingFeedback/EmpLifeCycle">{t('Employee Life Cycle Performance')}</NavLink>
                      </li>
                    )}

                    {/* Workforce Management */}
                    {role === 'Super Admin' && (
                      <li>
                        <NavLink to="/WorkForceMgmt">{t('Workforce Management')}</NavLink>
                      </li>
                    )}
                    {/* {role === 'Super Admin' && ( */}

              
                  </ul>
                </li>
              )}

            {/* <li className="menu nav-item relative">
            <button type="button" className="nav-link">
              <div className="flex items-center">
                <IconMenuUsers className="shrink-0" />
                <span className="px-1">{t('USER')}</span>
              </div>
              <div className="right_arrow">
                <IconCaretDown />
              </div>
            </button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/User/UserMgmt">{t('User Management')}</NavLink>
              </li>
              <li>
                <NavLink to="/User/Role">{t('Role')}</NavLink>
              </li>
              <li>
                <NavLink to="/User/MenuAccess">{t('Menu Access')}</NavLink>
              </li>
              <li>
                <NavLink to="/User/Teams">{t('Teams')}</NavLink>
              </li>
              <li>
                <NavLink to="/User/EmpList">{t('Employee Listing')}</NavLink>
              </li>
            </ul>
          </li> */}

            {/* {role === 'Assistant Manager' && ( 
          <li className="menu nav-item relative">
            <button type="button" className="nav-link">
              <div className="flex items-center">
                <IconMenuCharts className="shrink-0" />
                <span className="px-1">{t('DASHBOARD')}</span>
              </div>
              <div className="right_arrow">
                <IconCaretDown />
              </div>
            </button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/UserLevel">{t('User Level')}</NavLink>
              </li>
              <li>
                <NavLink to="/TeamLeader">{t('Team Leader')}</NavLink>
              </li>
              <li>
                <NavLink to="/SeniorManager">{t('Senior Manager')}</NavLink>
              </li>
              <li>
                <NavLink to="/AMDM">{t('AM/DM')}</NavLink>
              </li>
              <li>
                <NavLink to="/QualityManager">{t('Quality Manager')}</NavLink>
              </li>
              <li>
                <NavLink to="/QualityAuditor">{t('Quality Auditor')}</NavLink>
              </li>
              <li>
                <NavLink to="/GeneralManager">{t('General Manager')}</NavLink>
              </li>
              <li>
                <NavLink to="/SeniorDirector">{t('Senior Director')}</NavLink>
              </li>
              <li>
                <NavLink to="/ExecutiveManagement">{t('Executive Management')}</NavLink>
              </li>
            </ul>
          </li>
        )}  */}

            <li className="menu nav-item relative">
              <button type="button" className="nav-link">
                <div className="flex items-center">
                  <IconMenuCharts className="shrink-0" />
                  <span className="px-1">{t('PRODUCTION')}</span>
                </div>
                <div className="right_arrow">
                  <IconCaretDown />
                </div>
              </button>
              <ul className="sub-menu">
                {(role === 'Assistant Manager' || role === 'employee' || role === 'Super Admin') && (
                  <li>
                    <NavLink to="/Production/ProductionTemplate">{t('Production Template')}</NavLink>
                  </li>
                )}

                {/* {(role === 'Assistant Manager' || role === 'Super Admin') && (
                <li>
                  <NavLink to="/Production/AllocationReAllocation">{t('Allocation & ReAllocation')}</NavLink>
                </li>
              )} */}
                {(role === 'Assistant Manager' || role === 'Super Admin') && (
                  <li className="relative">
                    <button
                      type="button"
                      onClick={() => setAllocationTypeOpen(!isAllocationTypeOpen)}
                      className="flex items-center justify-between w-full whitespace-nowrap"
                    >
                      {t('Allocation & ReAllocation')}
                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                        <IconCaretDown />
                      </div>
                    </button>
                    {isAllocationTypeOpen && (
                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                        <li>
                          <NavLink to="/Production/AllocationReAllocation" className="block px-4 py-2 whitespace-nowrap">
                            {t('Excel File Allocation & Reallocation')}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/production/AllocationReallocationType2" className="block px-4 py-2 whitespace-nowrap">
                            {t('Pdf File Allocation & Reallocation')}
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                )}

                {(role === 'Assistant Manager' || role === 'employee' || role === 'Super Admin') && (
                  <li>
                    <NavLink to="/Production/AllocationFilesTemplate">{t('Allocated Files & Template')}</NavLink>
                  </li>
                )}

                {(role === 'Super Admin' || role === 'Assistant Manager') && (
                  <li>
                    <NavLink to="/Production/InventoryMgmt">{t('Inventory Management')}</NavLink>
                  </li>
                )}

                {(role === 'Assistant Manager' || role === 'employee' || role === 'Super Admin') && (
                  <li>
                    <NavLink to="/Production/OutputFileGeneration">{t('Output File Generation')}</NavLink>
                  </li>
                )}

                {/* {(role === 'Assistant Manager' || role === 'employee' || role === 'Super Admin') && (
                <li>
                  <NavLink to="/Production/SearchFileLogs">{t('Search File Logs')}</NavLink>
                </li>
              )} */}

                {/* {(role === 'Assistant Manager' || role === 'Super Admin') && (
                  <li className="relative" ref={menuRef}>
                    <button type="button" onClick={toggleCoaching}>
                      {t('Coaching Feedback')}
                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                        <IconCaretDown />
                      </div>
                    </button>
                    {isCoachingOpen && (
                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[220px] bg-white z-[40] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2"> */}
                {/* <li className="relative">
                          <NavLink to="/Production/CoachingFeedback/RCASearch">{t('RCA Search')}</NavLink>
                        </li>
                        <li className="relative">
                          <NavLink to="/Production/CoachingFeedback/POASearch">{t('POA Search')}</NavLink>
                        </li>
                        <li className="relative">
                          <NavLink to="/Production/CoachingFeedback/AREvaluationCatSearch">
                            {t('AR Evaulation Category Search')}
                          </NavLink>
                        </li>
                        <li className="relative">
                          <NavLink to="/Production/CoachingFeedback/AREvaluationSubCatSearch">
                            {t('AR Evaulation Sub Category Search')}
                          </NavLink>
                        </li> */}
                {/* <li className="relative">
                          <NavLink to="/Production/CoachingFeedback/SearchSupervisor">{t('Search Supervisor')}</NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                )} */}

                {(role === 'Super Admin' || role === 'Assistant Manager' || role === 'employee') && (
                  <li>
                    <NavLink to="/Production/CoachingFeedback/SearchSupervisor">{t('Coaching Feedback')}</NavLink>
                  </li>
                )}
                {/* 
                {(role === 'Assistant Manager' || role === 'Super Admin') && (
                  <li className="relative" ref={menuRef}>
                    <button type="button" onClick={toggleRTMainOpen}>
                      {t('Ramp Target')}
                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                        <IconCaretDown />
                      </div>
                    </button>
                    {isRTMainOpen && (
                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                        <li className="relative">
                          <button type="button" onClick={() => setRTSearchOpen(!isRTSearchOpen)}>
                            {t('Ramp Target Search')}
                            <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                              <IconCaretDown />
                            </div>
                          </button>
                          {isRTSearchOpen && (
                            <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                              <li className="relative">
                                <NavLink to="/RampTargetSearch/ScopeLevel">{t('Scope Level')}</NavLink>
                              </li> */}
                {/* <li>
                              <NavLink to="/RampTargetSearch/EmployeeLevel">{t('Employee Level')}</NavLink>
                            </li> */}
                {/* </ul>
                          )}
                        </li>
                      </ul>
                    )}
                  </li>
                )} */}

                {(role === 'Assistant Manager' || role === 'Super Admin') && (
                  <li className="relative" ref={menuRef}>
                    <button type="button" onClick={toggleMasters}>
                      {t('Masters')}
                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                        <IconCaretDown />
                      </div>
                    </button>
                    {isProdMastersOpen && (
                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                        <li className="relative">
                          <NavLink to="/Production/EndAction">{t('End Action')}</NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                )}

                <li className="relative" ref={menuRef}>
                  <button type="button" onClick={toggleProdReport}>
                    {t('Reports')}
                    <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                      <IconCaretDown />
                    </div>
                  </button>
                  {isProdReportOpen && (
                    <ul className="rounded overflow-auto absolute bottom-full ltr:right-0 ltr:left-40 rtl:left-0 min-w-[300px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow px-2 py-2 max-h-[100vh]">
                      {(role === 'Assistant Manager' || role === 'Super Admin' || role === 'employee') && (
                        <li className="relative">
                          <NavLink to="/Production/Reports/EmpPerformance">{t('Employee Performance')}</NavLink>
                        </li>
                      )}

                      {(role === 'Assistant Manager' || role === 'Super Admin' || role === 'employee') && (
                        <li>
                          <NavLink to="/Production/Reports/EmpPerformanceDashboard">
                            {t('Employee Performance Dashboard')}
                          </NavLink>
                        </li>
                      )}

                      {(role === 'Assistant Manager' || role === 'Super Admin' || role === 'employee') && (
                        <li>
                          <NavLink to="/Production/Reports/EmpDowntimeCap">{t('Employee Downtime Capturing')}</NavLink>
                        </li>
                      )}

                      {(role === 'auditor' || role === 'Quality Manager') && (
                        <li className="relative">
                          <NavLink to="/Production/Reports/AuditorPerformance">{t('Auditor Performance')}</NavLink>
                        </li>
                      )}

                      {(role === 'Assistant Manager' || role === 'Super Admin') && (
                        <li>
                          <NavLink to="/Production/Reports/InventoryVolAnalysis">{t('Inventory Volume Analysis')}</NavLink>
                        </li>
                      )}

                      {/* {(role === 'Assistant Manager' || role === 'Super Admin') && (
                        <li>
                          <NavLink to="/Production/Reports/ProdVsTarAnalysis">{t('Production Vs Target Analysis')}</NavLink>
                        </li>
                      )} */}

                      {(role === 'Assistant Manager' || role === 'Super Admin' || role === 'employee') && (
                        <li>
                          <NavLink to="/Production/Reports/SLASummarySupervisor">{t('SLA Summary & Detail')}</NavLink>
                        </li>
                      )}

                      {/* {(role === 'Assistant Manager' || role === 'Super Admin') && (
                      <li className="relative">
                        <NavLink to="/Production/Reports/PEPProcess">{t('PEP Possible Colleagues')}</NavLink>
                      </li>
                    )} */}

                      {(role === 'Assistant Manager' || role === 'Super Admin') && (
                        <li>
                          <NavLink to="/Production/Reports/ActivityTracker">{t('Activity Tracker')}</NavLink>
                        </li>
                      )}
                      {(role === 'Assistant Manager' || role === 'Super Admin') && (
                        <li>
                          <NavLink to="/Production/Reports/WholeActivity">{t('WholeActivity Report')}</NavLink>
                        </li>
                      )}
                      {(role === 'Assistant Manager' || role === 'Super Admin') && (
                        <li>
                          <NavLink to="/Production/Reports/ProductivityReport">{t('Productivity Report')}</NavLink>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              </ul>
            </li>

            {(role === 'Assistant Manager' ||
              role === 'Super Admin' ||
              role === 'auditor' ||
              role === 'Super Audit' ||
              role === 'Quality Manager' ||
              role === 'employee') && (
                <li className="menu nav-item relative">
                  <button type="button" className="nav-link">
                    <div className="flex items-center">
                      <IconMenuDocumentation className="shrink-0" />
                      <span className="px-1">{t('QUALITY CONTROL')}</span>
                    </div>
                    <div className="right_arrow">
                      <IconCaretDown />
                    </div>
                  </button>
                  <ul className="sub-menu">
                    {(role === 'Assistant Manager' ||
                      role === 'Super Admin' ||
                      role === 'auditor' ||
                      role === 'employee' ||
                      role === 'Quality Manager') && (
                        <li className="relative">
                          <button type="button" onClick={toggleAudit}>
                            {t('Audit')}
                            <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                              <IconCaretDown />
                            </div>
                          </button>
                          {isAuditOpen && (
                            <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                              {(role === 'Super Admin' || role === 'Quality Manager') && (
                                <li className="relative">
                                  <NavLink to="/QualityControl/Audit/AuditorAuditeeMapping">{t('Auditor Auditee Mapping')}</NavLink>
                                </li>
                              )}

                              {/* {(role==="Assistant Manager" || role==="Super Admin"  || role==="Quality Manager") &&
                    <li className="relative">
                      <NavLink to="/QualityControl/Audit/ViewAllocation">{t('View Allocation')}</NavLink>
                    </li>} */}

                              {/* {(role==="Assistant Manager" || role==="Super Admin"  || role==="Quality Manager") &&
                    <li className="relative">
                      <NavLink to="/QualityControl/Audit/Reallocation">{t('Reallocation')}</NavLink>
                    </li>} */}

                              {/* {( role==="Super Admin"  || role==="Quality Manager"|| role==="auditor") &&
                    <li className="relative">
                      <NavLink to="/QualityControl/Audit/AuditorSearch">{t('Auditor Search')}</NavLink>
                    </li>} */}

                              {(role === 'Super Admin' || role === 'auditor' || role === 'Quality Manager') && (
                                <li className="relative">
                                  <NavLink to="/QualityControl/Audit/AuditSamplingSearch">{t('Audit Sampling Search')}</NavLink>
                                </li>
                              )}
                              {/* {(role==="Assistant Manager" || role==="Super Admin"  || role==="auditor"  || role==="Quality Manager") &&
                    <li className="relative">
                      <button type="button" onClick={toggleAuditEntry}>
                        {t('Entry')}
                        <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                          <IconCaretDown />
                        </div>
                      </button>
                      {isAuditEntryOpen && (
                        <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                          <li>
                            <NavLink to="/QualityControl/Audit/Entry/DefectsPerUnit">{t('Defects Per Unit')}</NavLink>
                          </li>
                          
                        </ul>
                      )}
                    </li>} */}
                              {(role === 'Assistant Manager' ||
                                role === 'Super Admin' ||
                                role === 'auditor' ||
                                role === 'Quality Manager' ||
                                role === 'employee') && (
                                  <li className="relative">
                                    <button type="button" onClick={toggleAuditRebuttalEntry}>
                                      {t('Rebuttal')}
                                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                                        <IconCaretDown />
                                      </div>
                                    </button>
                                    {isAuditRebuttalOpen && (
                                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                                        <li className="relative">
                                          <NavLink to="/QualityControl/Rebuttal/ErrorQAManagerSearch">{t(title)}</NavLink>
                                        </li>

                                        <li className="relative">
                                          <NavLink to="/QualityControl/Rebuttal/QAFyiManagerSearch">{t(fyiStatusTitle)}</NavLink>
                                        </li>

                                        <li className="relative">
                                          <NavLink to="/QualityControl/Rebuttal/QAReWorkManagerSearch">{t(reWorkStatusTitle)}</NavLink>
                                        </li>
                                      </ul>
                                    )}
                                  </li>
                                )}
                                {(role === 'Assistant Manager' || role === 'Super Admin') && (
                                  <li>
                                    <NavLink to="/AssitantMangerAuditorError">{t('Assistant Manager Auditor Error')}</NavLink>
                                  </li>
                                )}
                            </ul>
                          )}
                        </li>
                      )}

                    {(role === 'Super Admin' ||
                      role === 'Super Audit' ||
                      role === 'Quality Manager' ||
                      role === 'auditor' ||
                      role === 'Assistant Manager') && (
                        <li className="relative" ref={menuRef}>
                          <button type="button" onClick={toggleSuperAudit}>
                            {t('Super Audit')}
                            <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                              <IconCaretDown />
                            </div>
                          </button>
                          {isSuperAuditOpen && (
                            <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                              {(role === 'Super Admin' || role === 'Quality Manager') && (
                                <li className="relative">
                                  <NavLink to="/QualityControl/SuperAudit/SupervisorAuditorMapping">
                                    {t('Supervisor Auditor Mapping')}
                                  </NavLink>
                                </li>
                              )}
                              {(role === 'Super Admin' ||
                                role === 'Super Audit' ||
                                role === 'Quality Manager' ||
                                role === 'Assistant Manager') && (
                                  <li className="relative">
                                    <NavLink to="/QualityControl/Audit/SuperAuditSamplingSearch">
                                      {t('Super Audit Sampling Search')}
                                    </NavLink>
                                  </li>
                                )}

                              {(role === 'Super Admin' ||
                                role === 'Super Audit' ||
                                role === 'Quality Manager' ||
                                role === 'Assistant Manager' ||
                                role === 'auditor') && (
                                  <li className="relative">
                                    <button type="button" onClick={toggleSuperAuditRebuttalEntry}>
                                      {t('Super Audit Rebuttal')}
                                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                                        <IconCaretDown />
                                      </div>
                                    </button>
                                    {isSuperAuditRebuttalOpen && (
                                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                                        <li className="relative">
                                          <NavLink to="/QualityControl/superAudit/SuperAuditRebuttal">{t(superAudititle)}</NavLink>
                                        </li>

                                        <li className="relative">
                                          <NavLink to="/QualityControl/superAudit/SuperAuditFyiStatusRebuttal">
                                            {t(superAuditFyiStatusitle)}
                                          </NavLink>
                                        </li>
                                      </ul>
                                    )}
                                  </li>
                                )}
                              {(role === 'Super Admin' || role === 'Super Audit' || role === 'Assistant Manager') && (
                                <li className="relative">
                                  <button type="button" onClick={toggleSuperAuditReport}>
                                    {t('Super Audit Report')}
                                    <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                                      <IconCaretDown />
                                    </div>
                                  </button>
                                  {SuperAuditReportOpen && (
                                    <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                                      <li className="relative">
                                        <NavLink to="/QualityControl/superAudit/SuperAuditDailyReport">
                                          {t('Super Audit Daily Report')}
                                        </NavLink>
                                      </li>
                                      <li className="relative">
                                        <NavLink to="/SuperAuditMTDReport">{t('Super Audit MTD Report')}</NavLink>
                                      </li>
                                    </ul>
                                  )}
                                </li>
                              )}
                            </ul>
                          )}
                        </li>
                      )}
                    {(role === 'Super Admin' || role === 'Quality Manager') && (
                      <li className="relative" ref={menuRef}>
                        <button type="button" onClick={toggleQATemplate}>
                          {t('Template')}
                          <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                            <IconCaretDown />
                          </div>
                        </button>
                        {isQATemplateOpen && (
                          <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[180px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                            <li className="relative">
                              <NavLink to="/QualityControl/Template/TemplateManagement">{t('Template Management')}</NavLink>
                            </li>
                          </ul>
                        )}
                      </li>
                    )}
                    {(role === 'Super Admin' ||
                      role === 'Quality Manager' ||
                      role === 'auditor' ||
                      role === 'Assistant Manager') && (
                        <li className="relative" ref={menuRef}>
                          <button type="button" onClick={toggleQAReport}>
                            {t('Reports')}
                            <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90 ">
                              <IconCaretDown />
                            </div>
                          </button>
                          {isQAReportOpen && (
                            <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[220px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2 overflow-auto max-h-[50vh]">
                              {/* Show these reports only to Super Admin & Quality Manager */}
                              {(role === 'Super Admin' || role === 'Quality Manager') && (
                                <>
                                  <li className="relative">
                                    <NavLink to="/CollLevelReport/AnalyTeamReport">{t('Analytical Team Report')}</NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/CollLevelReport/AWASTeamReport">{t('AWACS Team Report')}</NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/CollLevelReport/YearlyTrending">{t('Yearly Trending')}</NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/MTDAudCov">
                                      {t('MTD Audit Coverage & Accuracy Score')}
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/AuditorProdDet">{t('Auditor Production Detail')}</NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/AuditorProdSummary">
                                      {t('Auditor Production Summary')}
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/AuditorHrlyProd">{t('Auditor Hourly Production')}</NavLink>
                                  </li>

                                  <li>
                                    <NavLink to="/QualityControl/Reports/WeeklyProdQultyAnalysis">
                                      {t('Weekly Production & Quality Analysis')}
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/MonthlyQutrtErrAuditor">
                                      {t('Monthly/Quaterly Error Report Summary For Auditor')}
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink to="/QualityControl/Reports/ProjectScopeWise">
                                      {t('Project & Scope Wise Error Count for Auditor')}
                                    </NavLink>
                                  </li>
                                </>
                              )}
                              {(role === 'Super Admin' ||
                                role === 'Assistant Manager' ||
                                role === 'Quality Manager' ||
                                role === 'auditor') && (
                                  <li>
                                    <NavLink to="/QualityControl/Reports/QAReports">{t('QAReports')}</NavLink>
                                  </li>
                                )}
                              {(role === 'Super Admin' || role === 'Quality Manager' || role === 'auditor') && (
                                <li>
                                  <NavLink to="/QualityControl/Reports/QADailyReports">{t('QADailyReports')}</NavLink>
                                </li>
                              )}
                              {(role === 'Super Admin' || role === 'Quality Manager' || role === 'auditor') && (
                                <li>
                                  <NavLink to="/QualityControl/Reports/WeeklyQualityReport">{t('QAWeeklyReport')}</NavLink>
                                </li>
                              )}
                              {(role === 'Super Admin' || role === 'Quality Manager' || role === 'auditor') && (
                                <li>
                                  <NavLink to="/QualityControl/Reports/MonthlyQualityReports">{t('QAMonthlyReports')}</NavLink>
                                </li>
                              )}
                              {(role === 'Super Admin' || role === 'Quality Manager' || role === 'auditor') && (
                                <li>
                                  <NavLink to="/QualityControl/Reports/QualityReportsMain">{t(' Quality Mail Reports')}</NavLink>
                                </li>
                              )}
                            </ul>
                          )}
                        </li>
                      )}

                    {(role === 'Quality Manager' || role === 'Super Admin') && (
                      <li>
                        <NavLink to="/DailyTracker">{t('Daily Tracker')}</NavLink>
                      </li>
                    )}

                    {(role === 'Quality Manager' || role === 'Super Admin') && (
                      <li>
                        <NavLink to="/AuditorEfficiency">{t('Auditor Efficiency')}</NavLink>
                      </li>
                    )}

                    {(role === 'Super Admin' || role === 'Quality Manager' || role === 'Assistant Manager') && (
                      <li className="menu nav-item relative" ref={menuRef}>
                        <button type="button" onClick={toggleUpdateEmployeePerformance}>
                          {t('Update Employee Performance  ')}
                          <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90 ">
                            <IconCaretDown />
                          </div>
                        </button>
                        {toggleUpdateEmployeePerformanceData && (
                          <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[220px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2 overflow-auto max-h-[50vh]">
                            {/* Show these reports only to Super Admin & Quality Manager */}
                            {(role === 'Super Admin' || role === 'Quality Manager' || role === 'Assistant Manager') && (
                              <>
                                <li className="relative">
                                  <NavLink to="/UpdateEmployeePerformancedata">{t('UpdateEmployeePerformance')}</NavLink>
                                </li>
                              </>
                            )}
                          </ul>
                        )}
                      </li>
                    )}
                  </ul>
                </li>
              )}

            {/* Reports */}
            {/* {role === 'Super Admin' && (
              <li className="menu nav-item relative">
                <NavLink to="/BiReports/MainReports" className="nav-link">
                  <div className="flex items-center">
                    <IconMenuNotes className="shrink-0" />
                    <span className="px-1">{t('REPORTS')}</span>
                  </div>
                </NavLink>
              </li>
            )} */}
            {/* Incentive */}
            {/* {role === 'Super Admin' && (
              <li className="menu nav-item relative">
                <NavLink to="/Incentive" className="nav-link">
                  <div className="flex items-center">
                    <IconMenuNotes className="shrink-0" />
                    <span className="px-1">{t('Incentive')}</span>
                  </div>
                </NavLink>
              </li>
            )} */}

            {(role === 'Super Admin' || role === 'Assistant Manager') && (
              <li className="menu nav-item relative">
                <button type="button" className="nav-link">
                  <div className="flex items-center">
                    <IconBookmarks className="shrink-0" />
                    <span className="px-1">{t('PQA')}</span>
                  </div>
                  <div className="right_arrow">
                    <IconCaretDown />
                  </div>
                </button>
                <ul className="sub-menu">
                  {(role === 'Super Admin' || role === 'Assistant Manager') && (
                    <>
                      <li>
                        <NavLink to="/Ratings">{t('Ratings')}</NavLink>
                      </li>
                      {/* <li>
                        <NavLink to="/public/top5carousel">{t('🔝 Top 5 Dashboard')}</NavLink>
                      </li> */}
                      {/* <li>
                        <NavLink to="/Incentive">{t('Incentive')}</NavLink>
                      </li> */}
                    </>
                  )}
                </ul>
              </li>
            )}

            {/* {role === 'Super Admin' && (
             <li className="menu nav-item relative">
              <NavLink to="/RecognitionRewards" className="nav-link">
                <div className="flex items-center">
                  <Trophy className="shrink-0 mr-1 text-yellow-500" />
                  <span className="px-1">{t('Recognition & Rewards')}</span>
                </div>
              </NavLink>
            </li>
            )} */}

            <li className="menu nav-item relative">
              <button type="button" className="nav-link">
                <div className="flex items-center">
                  {/* Top-level icon ONLY */}
                  <Wrench className="shrink-0 mr-1 h-4 w-4 text-[#1A2B5C]" />
                  <span className="px-1">{t('Utilities')}</span>
                </div>
                <div className="right_arrow">
                  <IconCaretDown />
                </div>
              </button>

              <ul className="sub-menu">
                {/* Recognition & Rewards (flyout inside Utilities) */}
                {(role === 'Super Admin' || role === 'employee') && (
                  <li className="relative">
                    <button
                      type="button"
                      onClick={() => setIsRrOpen(!isRrOpen)}
                      className="flex items-center justify-between w-full whitespace-nowrap"
                    >
                      {t('Recognition & Rewards')}
                      <div className="ltr:ml-auto rtl:mr-auto rtl:rotate-90 -rotate-90">
                        <IconCaretDown />
                      </div>
                    </button>

                    {isRrOpen && (
                      <ul className="rounded absolute top-0 ltr:left-[95%] rtl:right-[95%] min-w-[220px] bg-white z-[10] text-secondary dark:text-white-dark dark:bg-[#1b2e4b] shadow p-0 py-2">
                        {/* Super Admin sees admin items */}
                        {role === 'Super Admin' && (
                          <>
                            <li>
                              <NavLink to="/AwardCategory" className="block px-4 py-2 whitespace-nowrap">
                                {t('Award Category')}
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/RecognitionRewards" className="block px-4 py-2 whitespace-nowrap">
                                {t('Recognition & Rewards')}
                              </NavLink>
                            </li>
                          </>
                        )}

                        {/* Employee sees employee views */}
                        {role === 'employee' && (
                          <>
                            <li>
                              <NavLink to="/EmployeRewards" className="block px-4 py-2 whitespace-nowrap">
                                {t('EmployeRewards')}
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/RedeemMain" className="block px-4 py-2 whitespace-nowrap">
                                {t('Redeem')}
                              </NavLink>
                            </li>
                          </>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {/* EprWhiteList — Super Admin only */}
                {/* {role === 'Super Admin' && (
                  <li>
                    <NavLink to="/EprWhiteList" className="block px-4 py-2 whitespace-nowrap">
                      {t('EprWhiteList')}
                    </NavLink>
                  </li>
                )} */}

                {/* Feedback — visible to ALL roles (no submenu icons) */}
                <li>
                  <NavLink to="/EPR/Feedback" className="block px-4 py-2 whitespace-nowrap">
                    {t('Feedback')}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/EPR/Holidays" className="block px-4 py-2 whitespace-nowrap">
                    {t('Holidays')}
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* <li className="menu nav-item relative">
            <button type="button" className="nav-link">
              <div className="flex items-center">
                <IconMenuDocumentation className="shrink-0" />
                <span className="px-1">{t('SUPPORT')}</span>
              </div>
              <div className="right_arrow">
                <IconCaretDown />
              </div>
            </button>
            <ul className="sub-menu">
              <li>
                <NavLink to="/Support/Documentation">{t('Documentation')}</NavLink>
              </li>
            </ul>
          </li> */}
          </ul>
        </div>
      </header>
      {/* Render UserLevelDashboards only if the path is "/" */}
      {role === 'employee' && location.pathname === '/' && (
        <div className="panel">
          <UserLevelDashboards />
        </div>
      )}
      {role === 'auditor' && location.pathname === '/' && (
        <div className="panel">
          <QualityAuditorMainTab />
        </div>
      )}
      {role === 'Assistant Manager' && location.pathname === '/' && (
        <div className="panel">
          <AMDMMainTab />
        </div>
      )}
      {role === 'Super Admin' && location.pathname === '/' && (
        <div className="panel">
          <MainReports />
        </div>
      )}
      {role === 'Quality Manager' && location.pathname === '/' && (
        <div className="panel">
          <QMDashboardMain />
        </div>
      )}
      {/* {showModal && ( */}
      {!EXEMPT_ROUTES.has(location.pathname) && showModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-md">
          <div className="bg-white p-8 rounded-xl text-center max-w-lg shadow-lg border-4 border-red-500 animate-pulse">
            <h2 className="text-3xl font-bold text-red-600 mb-4">⚠️ Inactivity Alert</h2>
            <p className="text-lg text-gray-800 mb-6">
              You will be logged out soon due to inactivity. Please confirm to stay logged in.
            </p>
            <button
              onClick={handleStayLoggedIn}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition shadow-lg"
            >
              I'm Active — Stay Logged In
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
